import React from 'react';
import './main.css';

const steps = [
  {
    number: '01',
    title: 'Choose the Vibe',
    description: 'Browse the lounge inclusions and pick the experience that fits the night.',
  },
  {
    number: '02',
    title: 'Check Availability',
    description: 'Message us on Telegram for open dates, details, and private coordination.',
  },
  {
    number: '03',
    title: 'Confirm & Arrive',
    description: "Secure the booking, arrive discreetly, and let the lounge take care of the rest.",
  },
];

const highlights = [
  'Private 18+ lounge',
  'All amenities included',
  'Telegram-first booking',
];

const Main = () => {
  return (
    <section className="main fade-section" id="book">
      <div className="main__inner">
        <p className="main__eyebrow">Simple, private, direct</p>
        <h2 className="main__heading">Reserve the Lounge</h2>
        <div className="main__highlights">
          {highlights.map((highlight) => (
            <span key={highlight}>{highlight}</span>
          ))}
        </div>
        <div className="steps-row">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="step">
                <span className="step__number">{step.number}</span>
                <h3 className="step__title">{step.title}</h3>
                <p className="step__description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step__connector"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Main;
